export enum SALES_DOCUMENT_TYPE_CODE {
  CONTRACT = 'A',
  SALES_ORDER = 'S',
  TOP_PRODUCTS = 'T',
  REGIONAL_PRODUCTS = 'R',
  APPROVED_PRODUCTS = 'P',
  COUNTRY_PRODUCTS = 'C',
  ADDITIONAL_SERVICES = 'Z',
}

export type ISalesDocumentTypeCode =
  | SALES_DOCUMENT_TYPE_CODE.CONTRACT
  | SALES_DOCUMENT_TYPE_CODE.SALES_ORDER
  | SALES_DOCUMENT_TYPE_CODE.TOP_PRODUCTS
  | SALES_DOCUMENT_TYPE_CODE.REGIONAL_PRODUCTS
  | SALES_DOCUMENT_TYPE_CODE.APPROVED_PRODUCTS
  | SALES_DOCUMENT_TYPE_CODE.COUNTRY_PRODUCTS
  | SALES_DOCUMENT_TYPE_CODE.ADDITIONAL_SERVICES;
